import { PageWithLayout } from '@/pages/_app';
import { Helmet } from 'react-helmet-async';
import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { FaceValidationPageContent } from '@/pageContents/faceValidationContent/FaceValidationPageContent';
import { Permission } from '@/models/user';

const FaceValidationPage: PageWithLayout = () => {
    return (
        <>
            <Helmet>Foto-Kalibrierung | Starjack Backoffice</Helmet>

            <FaceValidationPageContent />
        </>
    );
};

FaceValidationPage.isProtected = true;
FaceValidationPage.getLayout = (page) => <SidebarLayout>{page}</SidebarLayout>;
FaceValidationPage.permissions = [Permission.ADMIN];

export default FaceValidationPage;
